export const MAX_HTS_CODES = 32;
export const HTS_INDICES = Array.from(
  { length: MAX_HTS_CODES },
  (_, i) => i,
) as readonly number[];
